import { render } from "./ValidationForms.vue?vue&type=template&id=7ebe8691"
import script from "./ValidationForms.vue?vue&type=script&lang=js"
export * from "./ValidationForms.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Projetos\\WIP\\Reorganiza\\Leadcenter\\Dashboard\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__